import Accordion from 'accordion-js';

const dropdown = () => {
  const accordions = Array.from(document.querySelectorAll('.dropdown'));

  new Accordion(accordions, {
    duration: 200,
    elementClass: 'dropdown-item',
    triggerClass: 'dropdown-item__trigger',
    panelClass: 'dropdown-item__content'
  });
};

export default dropdown;
